import { Menu as BaseMenu } from '@base-ui/react/menu'

import { withPopupOpenMarker } from '@gto/ui/state-markers'

export const Trigger = ({ className, ...props }: BaseMenu.Trigger.Props) => (
  <BaseMenu.Trigger
    {...props}
    className={withPopupOpenMarker(className)}
  />
)
